// @flow

import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core/';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { Link } from 'react-scroll';

import './style.css';
type Props = {
    item: any,
    category: string
     
};
function ApiMenu(props: Props) {
    const { item, category } = props;

    return (
        <Typography component="div" className="api-side-nav">
            <List disablePadding dense className="menulink">
                <ListItem className="header">{category}</ListItem>
                {item.map((menuItem, index) => (
                    <React.Fragment key={`${menuItem.Item}${index}`}>
                        {
                            // <ListItem
                            //     className={`api-side-nav${
                            //         selectedMenu === menuItem.Item
                            //             ? ' active'
                            //             : ''
                            //     }`}
                            //     button
                            //     onClick={() => onClick(menuItem.Item)}
                            // >
                            //     <Grid container>
                            //         <Grid item sm={12} md={12} lg={12}>
                            <ListItem>
                                <Link
                                    to={menuItem.RefName}
                                    spy={true}
                                    smooth={true}
                                    offset={-200}
                                    duration={500}
                                    activeClass="active"
                                >
                                    {menuItem.Item}
                                </Link>
                            </ListItem>
                            //         </Grid>
                            //     </Grid>
                            // </ListItem>
                        }
                    </React.Fragment>
                ))}
            </List>
        </Typography>
    );
}

ApiMenu.propTypes = {
    depthStep: PropTypes.number,
    depth: PropTypes.number,
    selectedMenu: PropTypes.string,
    onMenuClick: PropTypes.func
};

export default ApiMenu;
